import { LocalAuth } from "@core/model/local-auth";
import { LocalProfile } from "@core/model/local-profile";

export class ApiToFormService {
  static MapLocalAuth(data: any): LocalAuth {
    const mappedData = {
      accessExpiry: data.access_exp,
      accessToken: data.access_token,
      refreshExpiry: data.refresh_exp,
      refreshToken: data.refresh_token,
      userCode: data.user_code,
      slug: data.role.slug || "",
      roleName: data.role.name || "",
    } as LocalAuth;

    return mappedData;
  }

  static MapProfile(data: any): LocalProfile {
    const mappedData = {
      code: data.code,
      name: `${data.last_name} ${data.first_name}`,
      roleId: data?.role,
      roleName: data?.role_name,
      username: data?.username,
      businessName: data?.business_name,
    } as LocalProfile;
    return mappedData;
  }
}
